import React, {Component} from 'react';
import NetworkAlert from './NetworkAlert/NetworkAlert';
import './NetworkFeedback.css';
import Outagedetails from '../OutageDetails/OutageDetails';
import OutageStatus from '../OutageStatus/OutageStatus';
import {Accordion, AccordionHeader, AccordionTitle, AccordionSubTitle, AccordionDetail, AccordionItem} from '@vds/accordions';
// import AccordionOld from '../../modules/Accordion';
import ReactHtmlParser from 'react-html-parser';
import {Chat} from '../../modules/IncludeChat';
import ErrorBoundary from '../../modules/ErrorHandler';
import {RemoveHeaderHiddenClass, checkUrlPath} from '../../modules/CommonFunctions';
import {SiteCatalyst} from '../../modules/SiteCatalyst';
import AlertBanner from '../../modules/AlertBanner';

class NetworkFeedback extends Component{
    toggleTab(e) {
        let tabItem = e.target;
        if (tabItem.classList.contains('tabs_tab') && !tabItem.classList.contains('active')) {
            let currentlySelectedItem = tabItem.parentElement.querySelector('.active');
            let currentlySelectedItemIndex = parseInt(currentlySelectedItem.getAttribute('data-item-index'), 10);
            let tabContentElements = document.querySelectorAll('.tab-content .panel')
            currentlySelectedItem.classList.remove('active');
            tabContentElements[currentlySelectedItemIndex].setAttribute('aria-hidden', true);
            tabContentElements[currentlySelectedItemIndex].classList.remove('active');
            currentlySelectedItem.setAttribute('aria-selected', false);
            tabItem.setAttribute('aria-selected', true);
            tabItem.classList.add('active');
            let tabContent = tabContentElements[parseInt(tabItem.getAttribute('data-item-index'), 10)];
            tabContent.setAttribute('aria-hidden', false);
            tabContent.classList.add('active');
        }
    }
    
    componentDidMount() {
        Chat();
        RemoveHeaderHiddenClass();
    }
    render(){
        const {outageStaticData, outageDynamicData} = this.props;
        
        const noDynamicdata = outageDynamicData.resourcesummary;
        let outageStatus ="";
        const isNooutage = noDynamicdata=== null;
        if(!isNooutage){
            outageStatus = noDynamicdata[0].insights.outagestatus;
        }

        return (
           
            <main className="FeedBack-Main outage">
                <div className="Feedback-sub">
                    <ErrorBoundary>
                        <div className="row">
                            <AlertBanner
                                AlertBannerData={this.props.AlertBanner}
                                isBreadCrumb={false}
                            />
                        </div>                
                    </ErrorBoundary>
                <ErrorBoundary>
                    <NetworkAlert outageData={window.soDynamicData}/>
                </ErrorBoundary>
                <ErrorBoundary>
                    <Outagedetails outageData={window.soDynamicData}/>
                </ErrorBoundary>
                </div>
                {/* Power Outages section */}
                {!isNooutage && outageStatus!=="RESOLVED"?<OutageStatus outageJson={window.soDynamicData}/>:null}
                {isNooutage || outageStatus === "RESOLVED"? <section className="padding-top-zero  power-outage" role="region">
                            <div className="row">
                                <div className="tiny-12 padding-horiz-tiny">
                                    <h2 className="outage-sub-heading">{outageStaticData.titledesc[0].title}</h2>
                                    <div className="margin-bottom-zero" dangerouslySetInnerHTML={{ __html: outageStaticData.titledesc[0].richText2 }}></div>
                                </div>
                            </div>
                            <ErrorBoundary>
                                <div class="row">
                                    <div class="tiny-12">
                                        <div className="accordian-wrap">
                                            <Accordion>
                                                {outageStaticData.accordions[0].accordionList.map(item => (
                                                    item.accordionrte && <AccordionItem>
                                                    <AccordionHeader 
                                                    triggerType="icon"
                                                    >      <AccordionTitle><span className="accordian-title">{item.accordianHeading}</span></AccordionTitle>
                                                    </AccordionHeader>
                                                    <AccordionDetail>
                                                    {ReactHtmlParser(item.accordionrte)}
                                                    </AccordionDetail>
                                                </AccordionItem>))}
                                            </Accordion>
                                        </div>
                                    </div>
                                </div>
                    {/* <AccordionOld HeaderClass="hide_header" Header="" DataSource={outageStaticData.accordions[0].accordionList}></AccordionOld> */}
                
                </ErrorBoundary>
                </section>: null}
                {/* Tabs Section */}
                { outageStatus!== "OPEN" ?  <section className="padding-top-zero medium-padding-vert-large tiny-padding-vert-tiny section-main" >
                                <div className="row" key="tab">
                                    <div className="tiny-12 padding-horiz-tiny">
                                        <h2 className="outage-sub-heading">{outageStaticData.titledesc[1].title}</h2>
                                        <p className="margin-bottom-zero" dangerouslySetInnerHTML={{ __html: outageStaticData.titledesc[1].richText2 }}></p>
                                    </div>
                                    <ul key="tabs" className="w_tabs m_margin m_article-tabs m_category-tabs" role="tab" tabIndex="0">
                                        {
                                            outageStaticData.tablist[0].tablist.map((item, index) => {
                                                return <li key={"tab" + index} id={item.tabId} className={(index === 0) ? "tabs_tab padding-bottom-small active" : "tabs_tab padding-bottom-small"}
                                                    aria-selected={(index === 0) ? true : false} role="tab" tabIndex="-1" data-item-index={index} onClick={this.toggleTab.bind(this)}>{item.tabHeading}</li>
                                            })
                                        }
                                    </ul>
                                    <div className="padding-bottom-medium tab-content-wrapper tab-content">
                                        {
                                            outageStaticData.tablist[0].tablist.map((item, index) => {
                                                return <React.Fragment key={"tab" + index}>
                                                    <div className={(index === 0) ? "panel bg-white margin-bottom-zero active" : "panel bg-white margin-bottom-zero"}>
                                                        <div className={(index === 3) ? "last-tab row" : "row"}>
                                                            <div className="columns tiny-12" >

                                                                {/* Common for all tabs */}
                                                                {ReactHtmlParser(item.tdlist[0].richText2)}

                                                                {/* Third Tab */}
                                                                {index === 2 ? ReactHtmlParser("<a class='button cta-text mw-large' role='button' data-track='Sign In' target='_self' href=" + '' + ">Sign In</a>") : ""}

                                                                {/* Second Tab */}
                                                                {(index === 1) ? ReactHtmlParser("<a class='button cta-text mw-large' role='button' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_BATT' data-track='Reset Now'>Reset Now</a>") : ""}
                                                                {((index === 1) && item.tdlist[1] !== undefined) ? ReactHtmlParser(item.tdlist[1].richText2) : ""}

                                                                {/* Fourth Tab */}
                                                                {index === 3 ? ReactHtmlParser("<a class='button cta-text mw-large' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_ASO' role='button' data-track='Fix all services out'>Fix all services out</a>") : ""}
                                                                {index === 3 ? ReactHtmlParser("<a class='button cta-text mw-large' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_STBRemotes' role='button' data-track='Fix Set-Top Box or Remote'>Fix Set-Top Box or Remote</a>") : ""}
                                                                {index === 3 ? ReactHtmlParser("<a class='button cta-text mw-large' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_ACO' role='button' data-track='Fix all TV channels out'>Fix all TV channels out</a>") : ""}
                                                                {index === 3 ? ReactHtmlParser("<a class='button cta-text mw-large' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_NDT' role='button' data-track='Fix no dial tone'>Fix no dial tone</a>") : ""}
                                                                {item.accordionDataList && <div class="row">
                                                                    <div class="tiny-12">
                                                                        <div className="accordian-wrap">
                                                                            <Accordion>
                                                                                {item.accordionDataList[0].accordionList.map(item => (
                                                                                    item.accordionrte && <AccordionItem>
                                                                                    <AccordionHeader 
                                                                                    triggerType="icon"
                                                                                    >      <AccordionTitle><span className="accordian-title">{item.accordianHeading}</span></AccordionTitle>
                                                                                    </AccordionHeader>
                                                                                    <AccordionDetail>
                                                                                    {ReactHtmlParser(item.accordionrte)}
                                                                                    </AccordionDetail>
                                                                                </AccordionItem>))}
                                                                            </Accordion>
                                                                        </div>
                                                                    </div>
                                                                </div>}
                                                                {/* <AccordionOld Header="" HeaderClass="hide" DataSource={(item.accordionDataList !== undefined) ? item.accordionDataList[0].accordionList : []}></AccordionOld> */}
                                                                <div className="row">
                                                                    <div className="column tiny-12 padding-horiz-tiny">
                                                                        {(index === 0 && item.tdlist[1] !== undefined) ? ReactHtmlParser(item.tdlist[1].richText2) : ""}
                                                                        {(index === 0) ? ReactHtmlParser("<a class='button cta-text mw-large' target='_blank' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_CCON' role='button' data-track='Fix Connection Issues'>Fix Connection Issues</a>") : ""}
                                                                        {(item.tdlist[2] !== undefined) ? ReactHtmlParser(item.tdlist[2].richText2) : ""}
                                                                        {(index === 0) ? ReactHtmlParser("<a class='button cta-text mw-large' target='_blank' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_ASO' role='button' data-track='Fix Service'>Fix Service</a>") : ""}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            })
                                        }
                                    </div>
                                </div>
                            </section>:null}
                            <ErrorBoundary>
                            <div class="row">
                                <div class="tiny-12">
                                    <div className="accordian-wrap">
                                        <Accordion>
                                            {outageStaticData.rtelist[0].richText && ReactHtmlParser(outageStaticData.rtelist[0].richText)}
                                            {outageStaticData.accordions[1].accordionList.map(item => (
                                                item.accordionrte && <AccordionItem>
                                                <AccordionHeader 
                                                triggerType="icon"
                                                >      <AccordionTitle><span className="accordian-title">{item.accordianHeading}</span></AccordionTitle>
                                                </AccordionHeader>
                                                <AccordionDetail>
                                                {ReactHtmlParser(item.accordionrte)}
                                                </AccordionDetail>
                                            </AccordionItem>))}
                                        </Accordion>
                                    </div>
                                </div>
                            </div>
                {/* <AccordionOld Header={outageStaticData.rtelist[0].richText} DataSource={outageStaticData.accordions[1].accordionList }/> */}
                </ErrorBoundary>
                <section id="networkTiles">
                    <div className="needassistance_wrapper">
                        <div className="networkLiveTiles">
                            <div className="row">
                                <div className="column-support">
                                    <h4 className="tile-assistance-header">
                                        {outageStaticData.collist[0].titleDescription[0].title}
                                    </h4>
                                    <ul className="tile-link-list">
                                        {outageStaticData.collist[0].ctaList && outageStaticData.collist[0].ctaList.map(
                                            (element,index)=> <li className="tile-link-item" key={"tileLink"+index}>
                                            <a target="_self" href={checkUrlPath(element.linkTo)} className="tile-link-anchor" id="liveChatSupport" data-track={element.label1}>{element.label1} >
                                             <div className="small-arrow right-caret tile-link-arrow"></div>
                                            </a>
                                        </li>
                                        )}
                                    </ul>
                                </div>

                                <div className="column-support">
                                    <h4 className="tile-assistance-header">
                                      {outageStaticData.collist[1].titleDescription[0].title}
                                    </h4>
                                    <p className="short_desc">{ReactHtmlParser(outageStaticData.collist[1].titleDescription[0].richText2)}</p>
                                    <ul className="tile-link-list">
                                        {outageStaticData.collist[1].ctaList && outageStaticData.collist[1].ctaList.map(
                                            (element,index)=>(
                                                <li className="tile-link-item" key={"chatLinkItem"+ index}>
                                            <a target="_self" href={checkUrlPath(element.linkTo)} className="tile-link-anchor" id="liveChatSupport" data-track={element.label1}>{element.label1} >
                                             <div className="small-arrow right-caret tile-link-arrow margin-right"></div>
                                            </a>
                                        </li>
                                            )
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <ErrorBoundary>
                    <SiteCatalyst PageDetails={this.props.outageStaticData.pagedetails}/>
                </ErrorBoundary>
            </main>
        )
    }
}

export default NetworkFeedback;



// WEBPACK FOOTER //
// ./src/components/NetworkOutage/NetworkFeedback/NetworkFeedback.js